module.exports = __webpack_public_path__ + "img/character-playing-both.599db6de.png";